import { UserServicesModel, Services } from '../models/UserServices';

export const hydrateUserService = (data: UserServicesModel): Services[] => {

  let services: Services[] = [];
  if(data.data) {
    services = data.data.map((service) => {
      return {
        NombreServicio: service.NombreServicio,
        IdServicio: service.IdServicio
      }
    });
  }

  return services;
}

